<div class="form-header">
    <h3 class="title">
      {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.TITLE' | translate }}
    </h3>
</div>
<mat-vertical-stepper #stepper [linear]="!firstStep.valid" class="stepper">
    <mat-step [stepControl]="firstStep">
      <form class="form" [formGroup]="firstStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_01.TITLE' | translate }}
        </ng-template>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_01.DATE' | translate }}
            </mat-label>
            <input matInput [matDatepicker]="dateOfSubmission" formControlName="dateOfSubmission" readonly required disabled
              autocomplete="off" [max]="maxDate" />
            <mat-datepicker-toggle matSuffix [for]="dateOfSubmission"></mat-datepicker-toggle>
            <mat-datepicker #dateOfSubmission></mat-datepicker>
          </mat-form-field>
        </field-holder>
        <field-holder kind="3-cols">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.FIRST_NAME' | translate }}</mat-label>
            <input matInput maxlength="250" type="text" formControlName="firstName" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.LAST_NAME' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="lastName" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.PARENT_NAME' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="parentName" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder kind="3-cols">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.GENDER' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="gender" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'NEW_SUBJECT.PERSONAL_DETAILS.DATE_OF_BIRTH' | translate }}
            </mat-label>
            <input matInput [matDatepicker]="dateOfBirth" formControlName="dateOfBirth" readonly disabled
              autocomplete="off" [max]="maxDate" />
            <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
            <mat-datepicker #dateOfBirth></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.JMBG' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="jmbg" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder kind="2-cols-1-2">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.ADDRESS.PHONE' | translate }}</mat-label>
            <input matInput maxlength="250" type="text" formControlName="phone" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.ADDRESS.ORIGIN_ADDRESS' | translate }}</mat-label>
            <input matInput maxlength="250" type="text" formControlName="permanentResidence" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.ADDRESS.RESIDENCE_ADDRESS' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="residence" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-select formControlName="signatory" [compareWith]="compareObjects" required>
                <mat-option *ngFor="let signatory of signatories; let i = index" [value]="signatory">{{ signatory }}</mat-option>
            </mat-select>
            <mat-label>{{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_01.SIGNATORY' | translate }}</mat-label>
            <mat-error *ngIf="firstStep.get('signatory').hasError('required')">{{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_01.SIGNATORY_ERROR' | translate}}</mat-error>
        </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperNext mat-stroked-button color="primary" [disabled]="!firstStep.valid"
            class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondStep">
        <form class="form" [formGroup]="secondStep">
          <ng-template matStepLabel>
            {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.TITLE' | translate }}
          </ng-template>
          <table mat-table [dataSource]="activityDataSource" #activityTable class="mb-16"
            *ngIf="activities.length > 0" style="width: -webkit-fill-available">
            
            <ng-container matColumnDef="activityDescription">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.ACTIVITY_DESCRIPTION' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                <span class="truncate" matTooltip="{{ element.value.activityDescription }}" matTooltipPosition="above">
                  {{ element.value.activityDescription }}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="activityGoal">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.ACTIVITY_GOAL' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <span class="truncate" matTooltip="{{ element.value.activityGoal }}" matTooltipPosition="above">
                  {{ element.value.activityGoal }}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="expectedOutcome">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.EXPECTED_OUTCOME' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <span class="truncate" matTooltip="{{ element.value.expectedOutcome }}" matTooltipPosition="above">
                  {{ element.value.expectedOutcome }}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="realizationPeriodFrom">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REALIZATION_PERIOD_FROM' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <span class="truncate" matTooltip="{{ element.value.realizationPeriodFrom | date:'dd.MM.yyyy.' }}" matTooltipPosition="above">
                  {{ element.value.realizationPeriodFrom | date:'dd.MM.yyyy.' }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="realizationPeriodTo">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REALIZATION_PERIOD_TO' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <span class="truncate" matTooltip="{{ element.value.realizationPeriodTo | date:'dd.MM.yyyy.' }}" matTooltipPosition="above">
                  {{ element.value.realizationPeriodTo | date:'dd.MM.yyyy.' }}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="reviewDeadline">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REVIEW_DEADLINE' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <span class="truncate" matTooltip="{{ element.value.reviewDeadline | date:'dd.MM.yyyy.' }}" matTooltipPosition="above">
                  {{ element.value.reviewDeadline | date:'dd.MM.yyyy.' }}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
            
              <td mat-cell *matCellDef="let element; let i = index">
            
                <button mat-icon-button class="button-square table__row-button" [matMenuTriggerFor]="menu">
                  <mat-icon class="button-square__icon">more_horiz</mat-icon>
                </button>
            
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editActivity(i)">
                    <mat-icon>edit</mat-icon>
                    {{ 'GLOBAL.EDIT' | translate }}
                  </button>
                  <button mat-menu-item (click)="removeActivity(i)">
                    <mat-icon>delete</mat-icon>
                    {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.REMOVE_ACTIVITY' | translate }}
                  </button> 
                </mat-menu>
              </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="displayedActivityColumns"></tr>
            <tr mat-row *matRowDef="let row; let i = index; columns: displayedActivityColumns"></tr>
          </table>
    
          <div class="button-holder">
            <button mat-flat-button color="primary" (click)="addActivity()"
              class="form-footer__button form-footer__button--secondary">
              <mat-icon>add</mat-icon>
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ADD_ACTIVITY' | translate }}
            </button>
          </div>
          <form-footer>
            <button matStepperPrevious mat-stroked-button color="primary"
              class="form-footer__button form-footer__button--secondary">
              {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
            </button>
            <button mat-flat-button mat-stroked-button (click)="preview()" [disabled]="
              (!firstStep.valid ||
              !secondStep.valid)" class="form-footer__button form-footer__button--secondary">
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.PREVIEW' | translate }}
            </button>
            <div>
              <button mat-flat-button color="primary" (click)="handleSubmit(); submitButton1.disabled = true;submitButton2.disabled = true;" [disabled]="
                (!firstStep.valid ||
                !secondStep.valid)" type="button" class="form-footer__button form-footer__button--primary" #submitButton1>
                {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.GENERATE' | translate }}
              </button>
            </div>
          </form-footer>
        </form>
      </mat-step>
</mat-vertical-stepper>
<button mat-stroked-button color="primary" (click)="closeForm()" type="button"
  class="form-footer__button form-footer__button--secondary">
  {{ 'DIALOG.CANCEL' | translate }}
</button>
<button mat-flat-button color="primary" (click)="save(false); submitButton1.disabled = true;submitButton2.disabled = true;" [disabled]="!firstStep.valid ||
  !secondStep.valid" class="form-footer__button form-footer__button--secondary" #submitButton2>
  {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.SAVE' | translate }}
</button>